import { render, staticRenderFns } from "./DeviationValue.vue?vue&type=template&id=2b3271e6&scoped=true&"
import script from "./DeviationValue.vue?vue&type=script&lang=js&"
export * from "./DeviationValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3271e6",
  null
  
)

export default component.exports